/**
 * DemocratCharts — replay playback loop.
 *
 * When `playing` is true, schedules stepForward() every (1000 / speed) ms.
 * Clears the timer on pause, speed change, or unmount.
 *
 * 1x = one candle per second.
 *   0.1x → 10s/candle (slow study)
 *   10x  → 100ms/candle (fast scrub)
 */

import { useEffect } from "react";
import { useReplayStore } from "@/store/replay";

export function useReplayPlayback() {
  const playing = useReplayStore((s) => s.playing);
  const speed = useReplayStore((s) => s.speed);
  const currentIndex = useReplayStore((s) => s.currentIndex);
  const totalCandles = useReplayStore((s) => s.totalCandles);
  const stepForward = useReplayStore((s) => s.stepForward);
  const pause = useReplayStore((s) => s.pause);

  useEffect(() => {
    if (!playing) return;
    if (currentIndex === null) return;
    if (currentIndex >= totalCandles - 1) {
      pause();
      return;
    }

    const intervalMs = Math.max(50, Math.round(1000 / speed));
    const id = setInterval(() => {
      stepForward();
    }, intervalMs);

    return () => clearInterval(id);
  }, [playing, speed, currentIndex, totalCandles, stepForward, pause]);
}
